import { useTranslationInvestor } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks';
import { Divider, Flex, Text } from '@mantine/core';
import { Autocomplete, TextInput } from 'react-hook-form-mantine';

import { EMPLOYEE_ID_FIELD, EMPLOYER_NAME_FIELD, employerOptionsFilter } from './employment.utils';

interface Props {
	employerOptions: string[];
}

export const EmploymentSection = ({ employerOptions }: Props) => {
	const tInvestor = useTranslationInvestor();

	return (
		<>
			<Text size="B5Bold" pb="1rem" pt="2rem">
				{tInvestor('investment.personal_details.employment')}
			</Text>
			<Flex gap="0.5rem" mb="2rem">
				<Autocomplete
					name={EMPLOYER_NAME_FIELD}
					label={tInvestor('investment.personal_details.employer_name')}
					placeholder={tInvestor('investment.personal_details.employer_name')}
					data={employerOptions}
					filter={employerOptionsFilter}
					size="md"
					sx={{ flex: 1 }}
				/>
				<TextInput
					name={EMPLOYEE_ID_FIELD}
					label={tInvestor('investment.personal_details.employee_id')}
					placeholder={tInvestor('investment.personal_details.employee_id')}
					size="md"
					sx={{ flex: 1 }}
				/>
			</Flex>

			<Divider my="2rem" />
		</>
	);
};
